import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';



const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  { path: 'manage-forms',loadChildren: () => import('./manage-forms/manage-forms.module').then(m => m.ManageFormsModule) },
  { path: 'manage-questions', loadChildren: () => import('./manage-questions/manage-questions.module').then(m => m.ManageQuestionsModule)  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
